declare function getValidAccessToken(): any;
declare function getChatbotIdForEnrollmentBot(): any;
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { IDToken, OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';
import { AssetsPath } from 'src/static-assets/assets-path';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-enrollment-agent',
  templateUrl: './enrollment-agent.component.html',
  styleUrls: ['./enrollment-agent.component.scss']
})
export class EnrollmentAgentComponent implements OnInit {
  public boxArea = "box1";
  public buttonArea = "btn-area";
  public showAcknowledge = false;
  public isDisabled = true;
  public disabledButton = false;
  public chatIconShow = false;
  public toShow = false;
  public assetsPath = AssetsPath;
  public toshowTick = false;
  public title = `Chat bots for ${environment.name} University`;
  public isVisible: boolean = false;
  public showDiv: boolean = true;
  acknowledged: boolean = false;
  showFullscreen: boolean = false;
  chatbotId: string = "";
  acknowledgmentVerified: string = 'false';
  public question1 = environment.Question1;
  public question2 = environment.Question2;
  public question3 = environment.Question3;
  public chatBotName: string = environment.chatbotName;
  public EnrollmentChatbotName: string = environment.EnrollmentChatbotName;
  public categoryList:any[] = [];
  public selectedCategory: any = '';
  public isFaqConfigurationEnable: any = environment.faqConfigurationEnable;
  // public FAQs = [
  //   {
  //     "queries": [
  //         "Reasons to choose CU University",
  //         "Support services available for CU University students",
  //         "Phone number for internal technical support at CU University"
  //     ]
  // },
  // ]
  // public showChatFAQs=[];
  public degreeCategoryList: any[] = ['Bachelor', 'Master', 'Doctoral', 'Education Specialist', 'Certificate'];
  public selectedDegreeCategory: any = '';
  public isDegreeCategorySelected: boolean = false;
  public FAQs = [
    {category:"Tuition & Fees",query:"What are the scholarship options available?"},
    {category:"Tuition & Fees",query:"What are the different modes are available?"},
    {category:"Tuition & Fees",query:"When will the scholarship be available?"},
    {category:"Tuition & Fees",query:"Am I eligible for scholarship?"},
    {category:"Tuition & Fees",query:"Tuition & Fees details for Tempo learning?"}
  ]
  
  public showChatFAQs=[];
  constructor(
    @Inject(OKTA_AUTH) public oktaAuth: OktaAuth
  ){}

  ngOnInit(){
    this.chatbotId = sessionStorage.getItem('chatbotIdEnr');
    this.acknowledgmentVerified = sessionStorage.getItem('acknowledgementVerified');
    const oktaToken = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken;
    sessionStorage.setItem('access_token',oktaToken.accessToken);
    this.userEnrollmentData();
}


  async userEnrollmentData(){
    const user = await this.oktaAuth.getUser();
    this.chatbotId = await getChatbotIdForEnrollmentBot();
    sessionStorage.setItem('userName',user.name)
    sessionStorage.setItem('userEmail',user.email);
    
    if ((this.chatbotId || this.chatbotId == null) && (this.acknowledgmentVerified !== 'true' || this.acknowledgmentVerified == null)) {
        this.checkAcknowledgment();
    } else if (this.acknowledgmentVerified == 'true') {
      this.showAcknowledge = false; 
      this.showFullscreen = true;
      this.boxArea = "box1 landing"
     this.buttonArea = "accepted_button";
      this.toshowTick = true;
     this.chatIconShow = true;
    }
  }

  public clickAcknowledgment()
{
  this.isDisabled = !this.isDisabled;
}

public readAcknowledgment()
{
  this.showAcknowledge= !this.showAcknowledge;
}
public startConversation(){
this.showAcknowledge= !this.showAcknowledge;
  this.boxArea = "box1 landing"
  this.buttonArea = "accepted_button";
  this.disabledButton = true;
  this.toshowTick = true;
  this.chatIconShow = true;
  const user_email = sessionStorage.getItem('userEmail');
  const mode = 'set';
  this.sendAcknowledgement(this.chatbotId, user_email, mode);
}
public closeButton()
{
  this.showAcknowledge = !this.showAcknowledge;
}

public toggleVisibility() {
  this.isVisible = !this.isVisible;
}


applyFAQsSelection(event: Event){
  const selectElement = event.target as HTMLSelectElement;
  this.selectedCategory = selectElement.value;
  // var applyFAQ = document.getElementById("applyFaq");
  // console.log('applyFAQ: ', applyFAQ);
  // applyFAQ.style.backgroundColor = "#C4C4C4";
  // var selectElement = document.getElementById("categorySelect") as HTMLSelectElement;
  // var selectedOption = selectElement.options[selectElement.selectedIndex].value;
  if (this.isFaqConfigurationEnable) {
  if(this.categoryList.length > 0){
    this.showChatFAQs=[];
    this.categoryList.forEach((FAQ)=>{
      if(this.selectedCategory === FAQ.category){
        this.showChatFAQs.push(...FAQ.queries);
      }
    });
    // applyFAQ.style.backgroundColor = "#FDB71A";
  }
} else {
  this.FAQs.forEach((FAQ)=>{
    
      this.showChatFAQs.push({'query':FAQ.query});
    
  })
}
  
}

maximizeChat() {
  const chatPopup = document.querySelector('.hk-chatbot-popup');
  if (chatPopup.classList.contains('maximized')) {
    chatPopup.classList.remove('maximized');
  } else {
    chatPopup.classList.add('maximized');
  }
}

fadeInFadeOut() {
  this.showDiv = !this.showDiv;
}

checkAcknowledgment() {
  // this.isDisabled= !this.isDisabled;
  const user_email = sessionStorage.getItem('userEmail');
  const mode = 'get';
  this.sendAcknowledgement(this.chatbotId, user_email, mode);
 }

acknowledgeTerms(checked: boolean) {
  this.acknowledged = checked;
  localStorage.setItem('termsAcknowledged', checked ? 'true' : 'false');
}


async sendAcknowledgement(chatbotId: string, userEmail: string, mode): Promise<void> {
  const body = new URLSearchParams();
  body.set('user_email', userEmail);
  body.set('mode', mode);
  body.set('chatbot_id', chatbotId);
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
  };
  const subscriptionKey = environment.enrollmentConfig.apimSubscriptionKeyForEnr;
  const token = await getValidAccessToken();
	if (environment.apimConfigurationEnable) {
		headers['Ocp-Apim-Subscription-Key'] = subscriptionKey;
		headers['AuthenticationType'] = 'Application';
    headers['Authorization'] = 'Bearer ' + token;
	}

  const response = await fetch(environment.commonConfig.acknowledgementAPI, {
    method: 'POST',
    headers: headers,
    body: body,
  });

  if (response.ok) {
    const responseData = await response.json();
    let acknowledgedStatus = responseData['Acknowledgement Status'];
    if (acknowledgedStatus === 'Not Found') {
      this.showAcknowledge = false; 
      sessionStorage.setItem('acknowledgementVerified', 'false');
      this.chatIconShow = false;
    } else if (acknowledgedStatus == 'yes'){
      this.showAcknowledge = false; 
      sessionStorage.setItem('acknowledgementVerified', 'true');
      //this.acknowledged = true;
      this.buttonArea = "accepted_button";
      this.toshowTick = true;
      this.chatIconShow = true;
    } else if (acknowledgedStatus == 'Success'){
     this.showAcknowledge = false;
     sessionStorage.setItem('acknowledgementVerified', 'true');
     this.boxArea = "box1 landing"
     this.buttonArea = "accepted_button";
    //  this.disabledButton = true;
     this.toshowTick = true;
     this.chatIconShow = true;
    }
    this.showFullscreen = true;
  } else {
    console.error('API error:', response.statusText);
  }
}

async logout(){
  const logoutUrl = '/enrollmentcopilot';
  sessionStorage.clear();
  this.removeAllCookies();
  await this.oktaAuth.signOut({postLogoutRedirectUri: `${environment.oktaSignoutRedirectUri}?returnUrl=${logoutUrl}`});
  sessionStorage.setItem('lastRoute','/enrollmentcopilot')
  await this.oktaAuth.signOut();
}

removeAllCookies(){
  const cookies = document.cookie.split(";");
  cookies.forEach(cookie => {
    const [name] = cookie.split("=");
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/enrollmentcopilot`;
  });
}

async getCategoryList(selectedDegreeCategory) {
  this.selectedCategory = 'Choose Category';
  this.categoryList = [];
  this.showChatFAQs = [];
  const body = JSON.stringify({
    chatbot_id: environment.enrollmentConfig.chatBotIdEnr,
    Level: selectedDegreeCategory,
    user_email: sessionStorage.getItem('userEmail')
  });
  let headers = {
		'Content-Type': 'application/json',
	}
  const subscriptionKey = environment.enrollmentConfig.apimSubscriptionKeyForEnr;
  const token = await getValidAccessToken();
	if (environment.apimConfigurationEnable) {
		headers['Ocp-Apim-Subscription-Key'] = subscriptionKey;
		headers['AuthenticationType'] = 'Application';
    headers['Authorization'] = 'Bearer ' + token;
	}
  const response = await fetch(environment.commonConfig.faqApi, {
    method: 'POST',
    headers: headers,
    body: body,
  });
  
  if(response.ok) {
    const responseData = await response.json();
    // this.selectedCategory = responseData.categories[0].category;
    this.categoryList = responseData.categories;
    this.selectedCategory = '';
    this.showChatFAQs = [];
    this.applyFAQsSelection(this.selectedCategory);
  }
  

}

applyDegreeSelection(event: Event) {
  const selectElement = event.target as HTMLSelectElement;
  this.selectedDegreeCategory = selectElement.value;
  console.log('selectedDegreeCategory: ', this.selectedDegreeCategory);
  this.isDegreeCategorySelected = true;
  this.getCategoryList(this.selectedDegreeCategory);
}

onclickFAQ(selectedDegreeCategory) {
  this.isDegreeCategorySelected = true;
  // this.getCategoryList(selectedDegreeCategory);
}
}
